// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","467":"component---src-pages-check-js","678":"component---src-pages-index-js"}[chunkId] + "-" + {"351":"508e33a7ebd8fae528d9","467":"693f97a7892c8b477d45","678":"aa530041157a377c4bef"}[chunkId] + ".js";
};